{
  "list": {
    "title": "Institutions",
    "description": "View and manage client institutions.",
    "search": "Search by name, city or owner email...",
    "filter": {
      "all": "All statuses",
      "status": {
        "none": "No subscription",
        "trialing": "Trial",
        "active": "Active",
        "paused": "Paused",
        "past_due": "Past due",
        "canceled": "Canceled",
        "incomplete": "Incomplete",
        "incomplete_expired": "Expired"
      }
    },
    "table": {
      "name": "Name",
      "owner": "Owner",
      "city": "City",
      "status": "Status",
      "seats": "Seats",
      "trialEndAt": "Trial end",
      "createdAt": "Created on"
    },
    "empty": {
      "title": "No institutions found",
      "description": "No institution matches your current search criteria."
    },
    "pagination": {
      "previous": "Previous",
      "next": "Next",
      "page": "Page {{current}} of {{total}}",
      "showing": "Showing {{from}} to {{to}} of {{total}} institutions"
    }
  },
  "detail": {
    "title": "Institution",
    "back": "Back",
    "notFound": "Institution not found",
    "viewOwner": "View owner account"
  },
  "section": {
    "title": "Institution",
    "description": "Manage this owner's institution",
    "infos": "Information",
    "subscription": "Subscription",
    "members": "Members",
    "displayName": "Name",
    "address": "Address",
    "city": "City",
    "state": "State",
    "zipCode": "Zip code",
    "country": "Country",
    "companyRegistration": "Registration",
    "subscriptionStatus": "Status",
    "noSubscription": "No subscription",
    "seatCount": "Seats",
    "complimentarySeatCount": "Complimentary seats",
    "billableSeatCount": "Billable seats",
    "edit": "Edit info",
    "offerSeat": "Offer a free seat",
    "addPractitioner": "Add a practitioner",
    "cancelSubscription": "Cancel subscription",
    "reactivateSubscription": "Reactivate subscription",
    "noMembers": "No members",
    "noOwnedInstitution": "This user does not own an institution yet",
    "institutionNotFound": "Institution not found",
    "memberType": {
      "complimentary": "Complimentary",
      "paid": "Billed"
    },
    "memberColumns": {
      "name": "Name",
      "email": "Email",
      "type": "Seat type",
      "createdAt": "Added on",
      "actions": "Actions"
    },
    "removeMember": "Remove this member",
    "removeMemberDialog": {
      "title": "Remove this member",
      "description": "Are you sure you want to remove {{name}} ({{email}}) from the institution? This will decrement the seat count.",
      "cancel": "Cancel",
      "confirm": "Remove"
    },
    "editDialog": {
      "title": "Edit institution",
      "description": "Update the institution information.",
      "cancel": "Cancel",
      "save": "Save"
    },
    "offerSeatDialog": {
      "title": "Offer a free seat",
      "description": "Create a new user in the institution without billing Stripe. The seat will be marked as complimentary and will never be billed.",
      "firstName": "First name",
      "lastName": "Last name",
      "email": "Email",
      "phone": "Phone",
      "password": "Initial password",
      "cancel": "Cancel",
      "confirm": "Offer seat"
    },
    "addMemberDialog": {
      "title": "Add a practitioner",
      "description": "Create a new billable user in the institution.",
      "firstName": "First name",
      "lastName": "Last name",
      "email": "Email",
      "phone": "Phone",
      "password": "Initial password",
      "cancel": "Cancel",
      "confirm": "Add",
      "disabledNoSubscription": "No active or trialing subscription for this institution.",
      "disabledTrialCap": "Trial seat limit reached."
    },
    "cancelSubscriptionDialog": {
      "title": "Cancel subscription",
      "description": "The Stripe subscription will be canceled at period end. The institution keeps access until the next billing date.",
      "cancel": "Cancel",
      "confirm": "Cancel subscription"
    },
    "reactivateSubscriptionDialog": {
      "title": "Reactivate subscription",
      "description": "The Stripe subscription will be reactivated immediately.",
      "cancel": "Cancel",
      "confirm": "Reactivate"
    },
    "trial": {
      "title": "Trial",
      "trialEndAt": "Trial end",
      "seats": "Seats",
      "paymentMethod": "Payment method",
      "cardOnFile": "Card on file",
      "noCard": "No card",
      "activate": "Activate trial",
      "reactivate": "Restart trial",
      "edit": "Edit trial",
      "end": "End trial",
      "status": {
        "none": "No subscription",
        "trialing": "Trial",
        "active": "Active",
        "paused": "Paused",
        "past_due": "Past due",
        "canceled": "Canceled",
        "incomplete": "Incomplete",
        "incomplete_expired": "Expired"
      }
    },
    "trialDialog": {
      "activateTitle": "Activate trial",
      "editTitle": "Edit trial",
      "description": "Configure the free trial end date and the maximum number of seats.",
      "trialEndAt": "Trial end date",
      "maxSeats": "Maximum seats",
      "maxSeatsPlaceholder": "No limit",
      "maxSeatsHint": "Leave empty to not limit the number of seats during the trial.",
      "cancel": "Cancel",
      "activateConfirm": "Activate trial",
      "editConfirm": "Save"
    },
    "endTrialDialog": {
      "title": "End trial",
      "description": "If the institution has a card on file, it will be billed immediately. Otherwise, the subscription will be paused and access blocked until a card is added.",
      "cancel": "Cancel",
      "confirm": "End trial"
    }
  },
  "success": {
    "institutionUpdated": "Institution updated successfully",
    "trialActivated": "Trial activated successfully",
    "trialUpdated": "Trial updated successfully",
    "trialEnded": "Trial ended successfully",
    "seatOffered": "Seat offered successfully",
    "memberAdded": "Practitioner added successfully",
    "memberRemoved": "Member removed successfully",
    "subscriptionCanceled": "Subscription canceled at period end",
    "subscriptionReactivated": "Subscription reactivated"
  },
  "errors": {
    "loadInstitutionFailed": "Failed to load institution",
    "loadInstitutionsFailed": "Failed to load institutions",
    "updateInstitutionFailed": "Failed to update institution",
    "offerSeatFailed": "Failed to offer the seat",
    "addMemberFailed": "Failed to add the practitioner",
    "removeMemberFailed": "Failed to remove member",
    "cancelSubscriptionFailed": "Failed to cancel subscription",
    "reactivateSubscriptionFailed": "Failed to reactivate subscription",
    "activateTrialFailed": "Failed to activate the trial",
    "updateTrialFailed": "Failed to update the trial",
    "endTrialFailed": "Failed to end the trial"
  }
}
